/**
 * Joins class names, dropping the ones that are not there.
 *
 * Every component in `ui/` takes an optional `className` so the caller can add
 * layout to it — spacing that belongs to the parent's arrangement, not to the
 * component — and each of them then has to merge that with its own base class.
 * This is that merge, once, so it cannot drift.
 *
 * It had drifted: the same join was written three ways across the folder, and
 * two of them disagreed about `className=""`. A `=== undefined` check keeps the
 * empty string and emits a trailing space; a truthy check drops it. Nobody
 * chose either — they were just written on different days. `cx` settles it by
 * dropping empty strings, so the joined result never carries a blank segment
 * and `class=""` never appears in the DOM.
 *
 * `false` is accepted alongside `null`/`undefined` so a conditional modifier can
 * be written inline (`cx('chip', selected && 'chip--selected', className)`)
 * without each call site inventing its own ternary-to-null dance.
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
